module.exports = __webpack_public_path__ + "img/es.79407f7.webp";